import { Bookmark, FileText } from "lucide-react"
import { Button } from "../ui/button"
import { Card } from "../ui/card"
import { Badge } from "../ui/badge"

export function NotesTab() {
  return (
    <Card className="p-5 bg-white shadow-md">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-base font-semibold flex items-center">
          <FileText className="h-4 w-4 mr-2 text-[#FF5533]" />
          Application Notes
        </h3>
        <Button variant="outline" size="sm">
          <Bookmark className="h-4 w-4 mr-1" />
          Add Note
        </Button>
      </div>

      <div className="space-y-4">
        <div className="p-4 border rounded-md">
          <div className="flex justify-between items-start mb-2">
            <div>
              <h4 className=" font-medium">Initial Review Complete</h4>
              <p className="text-sm text-gray-500">Added by John Smith • April 15, 2025 at 2:30 PM</p>
            </div>
            <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
              Review
            </Badge>
          </div>
          <p className=" text-gray-700">
            Completed initial review of the application. All required documents have been received. The manufacturing
            processes appear to be within our underwriting guidelines, but we need additional information about their
            chemical handling procedures.
          </p>
        </div>

        <div className="p-4 border rounded-md">
          <div className="flex justify-between items-start mb-2">
            <div>
              <h4 className=" font-medium">Missing Safety Documentation</h4>
              <p className="text-sm text-gray-500">Added by Sarah Johnson • April 14, 2025 at 11:15 AM</p>
            </div>
            <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
              Information Request
            </Badge>
          </div>
          <p className=" text-gray-700">
            Requested additional safety documentation from the agent. Specifically, we need the most recent safety
            inspection report and employee training records for handling hazardous materials.
          </p>
        </div>

        <div className="p-4 border rounded-md">
          <div className="flex justify-between items-start mb-2">
            <div>
              <h4 className=" font-medium">Application Received</h4>
              <p className="text-sm text-gray-500">Added by System • April 12, 2025 at 9:45 AM</p>
            </div>
            <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
              System
            </Badge>
          </div>
          <p className=" text-gray-700">
            Application #A-12345 for Rubber Mill, Inc. has been received and assigned to the underwriting team. Initial
            classification: Application Renewal.
          </p>
        </div>
      </div>
    </Card>
  )
}
